export default __webpack_public_path__ + "static/media/PrateekNarang.c3086142.jpg";